import { createPinia, defineStore } from 'pinia'

export const pinia = createPinia()

interface BaseState {
  loadingState: boolean
  numberOfRunningJobs: number
}

export const useBaseStore = defineStore('baseStore', {
  state: (): BaseState => ({
    loadingState: false,
    numberOfRunningJobs: 0,
  }),
  getters: {
    getLoadingState(): boolean {
      return this.loadingState
    },
    getNumberOfRunningJobs(): number {
      return this.numberOfRunningJobs
    },
  },
  actions: {
    setLoading(loading: boolean) {
      this.loadingState = loading
    },
    incrementRunningJobs() {
      this.numberOfRunningJobs += 1
    },
    decrementRunningJobs() {
      this.numberOfRunningJobs -= 1
      if (this.numberOfRunningJobs <= 0) {
        this.numberOfRunningJobs = 0
        this.setLoading(false)
      }
    },
    startNewJob() {
      if (!this.loadingState) this.setLoading(true)
      this.incrementRunningJobs()
    },
  },
})
